import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, Fragment, useRef } from "react";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
// import FileViewer from 'react-file-viewer';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
import { Typography, Box, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, IconButton, Avatar, Grid, Tooltip } from '@mui/material';
import { useMessage } from "../../context/message-context";
import DeleteIcon from '@mui/icons-material/Delete';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import openFile from "../shared/functions/download";
import { FullPageSpinner } from '../lib';
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import MessageBox from '../shared/components/MessageBox';

function MyDocuments(props) {
  const { t } = useTranslation();
  const { client, accessToken } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mydocuments, setMydocuments] = useState(null);
  const [sentdocuments, setSentdocuments] = useState(null);
  const { hideMessage, showErrorMessage } = useMessage();
  const [myDocumentsMessageBoxOpen, setMyDocumentsMessageBoxOpen] = useState(false);
  const [sentDocumentsMessageBoxOpen, setSentDocumentsMessageBoxOpen] = useState(false);
  const { loeschZeile, setLoeschZeile } = useMessage('');
  const { loeschArt, setLoeschArt } = useMessage('');
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": "DMSBAP",
      "statement": "DATEIEN",
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, documentsCb);
    //eslint-disable-next-line
  }, []);
  const documentsCb = (response) => {
    if (response.status === 200) {
      setMydocuments(response.data.documents);
      setSentdocuments(response.data.sentdocuments);
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message)
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const downloadFile = (key, name) => {
    console.log('file with key: ', key);
    const payload = {
      "mandant": client,
      "program": "DMSBAP",
      "statement": "DOWNLOAD",
      "document": key,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    axios.post(API_BASE_URL + 'daten', payload, { headers: headers, responseType: 'blob' })
      .then((response) => {
        var contentFile = response.data;
        const mimeType = response.headers['content-type'] || 'application/pdf'
        openFile(name, contentFile, mimeType);
        closeModal();
      })
      .catch(function (error) {
        closeModal();
        showErrorMessage(t("Datei konnte nicht geladen werden"));
        console.log(error);
      });
  }
  const openMyDocumentsMessageBox = () => {
    setMyDocumentsMessageBoxOpen(true);
  }
  const closeMyDocumentsMessageBox = () => {
    setMyDocumentsMessageBoxOpen(false);
  }
  const openSentDocumentsMessageBox = () => {
    setSentDocumentsMessageBoxOpen(true);
  }
  const closeSentDocumentsMessageBox = () => {
    setSentDocumentsMessageBoxOpen(false);
  }
  function messageBoxResult(r) {
    if (r === "YES") {
      loeschen();
    }
    closeSentDocumentsMessageBox();
    closeMyDocumentsMessageBox();
  }
  const handleDeleteClick = (event, art, zeile) => {
    event.stopPropagation();
    setLoeschZeile(zeile);
    setLoeschArt(art);
    switch (art) {
      case "mydoc":
        openMyDocumentsMessageBox();
        break;
      case "sentdoc":
        openSentDocumentsMessageBox();
        break;
      default:
        break;
    }
  }
  const loeschen = () => {
    var payload = {}
    switch (loeschArt) {
      case "mydoc":
        payload = {
          "mandant": client,
          "program": "DMSBAP",
          "statement": "BERECHT_LOESCHEN",
          "document": mydocuments[loeschZeile].key,
        }
        break;
      case "sentdoc":
        payload = {
          "mandant": client,
          "program": "DMSBAP",
          "statement": "BERECHT_LOESCHEN",
          "document": sentdocuments[loeschZeile].key,
        }
        break;
      default:
        break;
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, loeschenCB);
  }
  const loeschenCB = (response) => {
    if (response.status === 200) {
      var array = ""
      if (loeschArt === "mydoc") {
        array = [...mydocuments]
        array.splice(loeschZeile, 1)
        setMydocuments(array);
      }
      if (loeschArt === "sentdoc") {
        array = [...sentdocuments]
        array.splice(loeschZeile, 1)
        setSentdocuments(array);
      }
      loeschZeile = "";
      loeschArt = "";
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const closeModal = () => {
    setShowModal(false);
  }
  const open = (key, name) => {
    setShowModal(true);
    downloadFile(key, name);
  }
  if (isLoading) {
    return <LoadingComponent path={props.location} />
  }
  const displayMyDocuments = (mydocuments && mydocuments.length > 0) ? mydocuments.map((dataObject, count) => {
    const name = dataObject.name;
    const key = dataObject.key;
    const fromdate = dataObject.fromdate;
    const todate = dataObject.todate;
    const fromuser = dataObject.from_user;
    const state = dataObject.state;
    var backColor = "";
    if (state === 'ungelesen') backColor = "rgb(244, 067, 054, 0.8)"
    if (state === 'warning') backColor = "rgb(253, 200, 69, 0.8)"
    if (state === 'gelesen') backColor = "rgb(076, 175, 080, 0.5)"

    return (
      <TableRow hover key={key} onClick={() => open(key, name)} style={{ cursor: 'pointer' }}>
        <TableCell padding="checkbox">
          <Avatar style={{ backgroundColor: backColor }}>
            {state === 'ungelesen' ?
              <Tooltip title={t("ungelesen")}>
                <ErrorIcon />
              </Tooltip>
              : state === 'gelesen' ?
                <Tooltip title={t("gelesen")}>
                  <CheckCircleIcon />
                </Tooltip>
                :
                <Tooltip title={t("warnung")}>
                  <ErrorIcon />
                </Tooltip>
            }
          </Avatar>
        </TableCell>
        <TableCell>{name}</TableCell>
        <TableCell>{fromuser}</TableCell>
        <TableCell>{fromdate}</TableCell>
        <TableCell>{todate}</TableCell>
        <TableCell>{state}</TableCell>
        {/* <TableCell padding="checkbox">
          <Tooltip title={t("Berechtigung entfernen")}>
            <IconButton variant="contained" onClick={(event) => handleDeleteClick(event, "mydoc", count)} ><DeleteIcon fontSize="large" /></IconButton>
          </Tooltip>
        </TableCell> */}
      </TableRow>
    );
  }) : <TableRow key="nofile"><TableCell colSpan={7}>{t("Keine bereitgestellten Dokumente")}</TableCell></TableRow>;
  const displaySentDocuments = (sentdocuments && sentdocuments.length > 0) ? sentdocuments.map((dataObject, count) => {
    const name = dataObject.name;
    const key = dataObject.key;
    const fromdate = dataObject.fromdate;
    const todate = dataObject.todate;
    const touser = dataObject.to_user;
    const state = dataObject.state;
    var backColor = "";
    if (state === 'ungelesen') backColor = "rgb(244, 067, 054, 0.8)"
    if (state === 'warning') backColor = "rgb(253, 200, 69, 0.8)"
    if (state === 'gelesen') backColor = "rgb(076, 175, 080, 0.5)"
    return (
      <TableRow hover key={key} onClick={() => open(key, name)} style={{ cursor: 'pointer' }}>
        <TableCell padding="checkbox">
          <Avatar style={{ backgroundColor: backColor }}>
            {state === 'ungelesen' ?
              <Tooltip title={t("ungelesen")}>
                <ErrorIcon />
              </Tooltip>
              : state === 'gelesen' ?
                <Tooltip title={t("gelesen")}>
                  <CheckCircleIcon />
                </Tooltip>
                :
                <Tooltip title={t("warnung")}>
                  <ErrorIcon />
                </Tooltip>
            }
          </Avatar>
        </TableCell>
        <TableCell>{name} </TableCell>
        <TableCell>{touser}</TableCell>
        <TableCell>{fromdate}</TableCell>
        <TableCell>{todate}</TableCell>
        <TableCell>{state}</TableCell>
          {/* <TableCell padding="checkbox">
            <Tooltip title={t("Berechtigung entfernen")}>
              <IconButton variant="contained" onClick={(event) => handleDeleteClick(event, "sentdoc", count)}><DeleteIcon fontSize="large" /></IconButton>
            </Tooltip>
          </TableCell> */}
      </TableRow>
    );
  }) : <TableRow key="nofile"><TableCell colSpan={7}>{t("Keine Dokumente bereitgestellt")}</TableCell></TableRow>;

  return (
    <Page>
      <Layout fullWidth>
        <Typography variant="h5" color="primary" >{t("Mit mir geteilte Dokumente")}</Typography>
      </Layout>
      <Layout>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox"></TableCell>
                <TableCell>{t("Name")}</TableCell>
                <TableCell>{t("Von User")}</TableCell>
                <TableCell>{t("Bereitgestellt am")}</TableCell>
                <TableCell>{t("Bis")}</TableCell>
                <TableCell>{t("Status")}</TableCell>
                {/* <TableCell padding="checkbox"></TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {displayMyDocuments}
            </TableBody>
          </Table>
        </TableContainer>
      </Layout>
      <Layout fullWidth>
        <Typography variant="h5" color="primary" >{t("Von mir geteilte Dokumente")}</Typography>
      </Layout>
      <Layout>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox"></TableCell>
                <TableCell>{t("Name")}</TableCell>
                <TableCell>{t("Für User")}</TableCell>
                <TableCell>{t("Bereitgestellt am")}</TableCell>
                <TableCell>{t("Bis")}</TableCell>
                <TableCell>{t("Status")}</TableCell>
                <TableCell padding="checkbox"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displaySentDocuments}
            </TableBody>
          </Table>
        </TableContainer>
      </Layout>
      {showModal && <FullPageSpinner />}
      {mydocuments &&
        <MessageBox
          title={t("Hinweis")}
          text={"Wollen Sie die Berechtigung für das Dokument " + mydocuments[loeschZeile] + " wirklich entfernen?"}
          buttons="YESNO"
          onClose={closeMyDocumentsMessageBox}
          open={myDocumentsMessageBoxOpen}
          handleResponse={messageBoxResult}
        />
      }
      {sentdocuments &&
        <MessageBox
          title={t("Hinweis")}
          text={"Wollen Sie die Berechtigung für das Dokument " + sentdocuments[loeschZeile] + " wirklich entfernen?"}
          buttons="YESNO"
          onClose={closeSentDocumentsMessageBox}
          open={sentDocumentsMessageBoxOpen}
          handleResponse={messageBoxResult}
        />
      }
    </Page>
  )
}
export default MyDocuments;
